import { rProtected } from './routes/protected.routes'
import { rAuth } from './routes/auth.routes'
import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import store from '@/store/index'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'EarthLink',
    component: () => import('@/layouts/HeaderLayout.vue'),
    children: rProtected,
    beforeEnter: function(to, from, next) {
      if (store.getters['auth/isAuthenticated']) next()
      else next({ path: 'auth', query: { redirect: to.path } })
    }
  },
  {
    path: '/auth',
    name: 'Auth',
    component: () => import('@/views/auth/AuthPage.vue'),
    children: rAuth,
    beforeEnter: (to, from, next) => {
      if (!store.getters['auth/isAuthenticated']) next()
      else next({ path: from.path })
    }
  },
  {
    path: '/view-report',
    name: 'report',
    component: () => import('../views/SubscriberReport.vue')
  },
  {
    path: '/user-service',
    name: 'verification',
    component: () => import('../views/UserService.vue')
  },
  {
    // Last, so it only takes an address no other route claims. Without it the router
    // matched nothing and rendered nothing: a blank page. Open to everyone, and the
    // address is kept so a typo can be corrected.
    path: '/:pathMatch(.*)*',
    name: 'not-found',
    component: () => import('../views/NotFound.vue')
  }
]

// Routes by path, so an address has no '#'.
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior() {
    // always scroll to top
    return { top: 0 }
  }
})
router.beforeEach(async (to, from, next) => {
  await store.dispatch('auth/fetchUser')
  next()
})

export default router
